import { FC, StrictMode } from 'react';

import PageLayout from 'src/app/layouts/PageLayout';
import PriceTabContentWrapper from 'src/components/Price/PriceTabContentWrapper';
import { useSelector } from 'src/hooks/useSelector';

import TabContent from 'src/pages/PriceZp/components/TabContent';

const PriceZp: FC = () => {
    const { description, pageTitle } = useSelector(({ pricePageMetaInfo }) => pricePageMetaInfo);

    return (
        <StrictMode>
            <PageLayout description={description} title={pageTitle}>
                <PriceTabContentWrapper>
                    <TabContent />
                </PriceTabContentWrapper>
            </PageLayout>
        </StrictMode>
    );
};

export default PriceZp;
